"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Recipients/UploadCsvDialog.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);


var _CsvImportDialog = require('./CsvImportDialog'); var _CsvImportDialog2 = _interopRequireDefault(_CsvImportDialog);
var _CampaignCsvSteps = require('./CampaignCsvSteps'); var _CampaignCsvSteps2 = _interopRequireDefault(_CampaignCsvSteps);














/* The broadcast as a CSV import's target: columns map to patient fields or
 * the campaign's variables, and the file is read with the campaign's preview. */
const useCampaignSource = (campaign) => {
  const { CampaignKey: campaignKey, TemplateFields: fields } = campaign
  const preview = _react.useCallback.call(void 0, 
    (fileKey, mapping) => _actions2.default
      .previewCampaignRecipients({
        CampaignKey: campaignKey,
        Sources: [mapping ? { Kind: 'file', FileKey: fileKey, Mapping: mapping } : { Kind: 'file', FileKey: fileKey }],
      })
      .then(result => {
        const summary = result.Sources[0]
        if (_optionalChain([summary, 'optionalAccess', _ => _.Kind]) !== 'file') throw new Error('no file summary')
        return { Columns: summary.Columns, Headers: summary.Headers, Mapping: summary.Mapping, Rows: _nullishCoalesce(_optionalChain([summary, 'access', _2 => _2.Counts, 'optionalAccess', _3 => _3.Rows]), () => ( 0)) }
      }),
    [campaignKey],
  )
  const declared = _react.useMemo.call(void 0, () => new Set(fields.map(f => f.Name)), [fields])
  return _react.useMemo.call(void 0, 
    () => ({ title: 'Add from CSV', stepCount: 2, allowVariables: true, declared, preview }),
    [declared, preview],
  )
}

/* Rev 31 v2 · 4: Add from CSV, on the wizard's Recipients step and the
 * campaign page alike: choose a file and map its columns (CsvImportDialog),
 * then review its rows and Add. */
const UploadCsvDialog = ({ isOpen, campaign, onClose, onAdd, onSetDefault }) => {
  const source = useCampaignSource(campaign)
  return (
    _react2.default.createElement(_CsvImportDialog2.default, {
      isOpen: isOpen,
      source: source,
      onClose: onClose,
      renderSteps: steps => (
        _react2.default.createElement(_CampaignCsvSteps2.default, { ...steps, campaign: campaign, onAdd: onAdd, onSetDefault: onSetDefault, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} )
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
    )
  )
}

exports. default = _react.memo.call(void 0, UploadCsvDialog)
